import UserService from '../services/UserService';
import AdminService from '../services/AdminService';
import { saveAuthData, getAuthData, getTokenData } from './authStorage';
import { useUserStore } from '../store';

const parseRoles = (tokenData) => {
  const rawRoles =
    tokenData?.role ?? tokenData?.roles ?? tokenData?.Role ?? tokenData?.Roles;
  if (Array.isArray(rawRoles)) return rawRoles;
  if (typeof rawRoles === 'string')
    return rawRoles.split(/[ ,]+/).filter(Boolean);
  return [];
};

const hasRole = (rolesList, roleName) =>
  rolesList.some((r) => String(r).toLowerCase() === roleName);

const applyTokenContextToStore = () => {
  const tokenData = getTokenData() || {};
  const rolesList = parseRoles(tokenData);
  const isClient = hasRole(rolesList, 'client');
  const isInterviewer = hasRole(rolesList, 'interviewer');

  const store = useUserStore.getState();
  store.setUserRoles(rolesList);
  store.setIsClient(isClient);
  store.setIsInterviewer(isInterviewer);
  store.setCompanyId(tokenData.companyId || null);
  store.setIsAgency(
    tokenData.tenantType === 'Agency' && !isClient && !isInterviewer
  );

  return { rolesList, isClient, isInterviewer };
};

const checkScreeningAvailability = async () => {
  try {
    const response = await AdminService.getTenantAssessmentProviders({
      term: '',
      pageSize: 9999,
    });
    const hasProviders =
      response?.data &&
      Array.isArray(response.data) &&
      response.data.length > 0;
    useUserStore.getState().setScreeningAvailable(hasProviders);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to check screening availability:', error);
    useUserStore.getState().setScreeningAvailable(false);
  }
};

export const getDestinationForRoles = ({ isInterviewer, isClient }) => {
  if (isInterviewer) return '/tools/interview-dashboard';
  if (isClient) return '/tools/company-dashboard';
  return '/tools/discover';
};

// Selects the given tenant context, persists the resulting auth token,
// hydrates the user store from the new token and navigates the user to the
// appropriate landing page based on their roles.
export const selectContextAndNavigate = async ({ tenantId, navigate }) => {
  const response = await UserService.selectContext({ tenantId });
  const { userId, userName } = getAuthData();
  saveAuthData({
    accessToken: response.token,
    userName: response.userName || userName,
    userId: response.userId || userId,
  });

  const { isClient, isInterviewer } = applyTokenContextToStore();
  await checkScreeningAvailability();

  navigate(getDestinationForRoles({ isInterviewer, isClient }));
};
